"use strict";
// @ts-ignore
try {
    self['workbox:window:5.1.4'] && _();
}
catch (e) { }
